class Quiz extends HTMLElement {
    constructor() {
        super();

        this.currentPage = 0;

        this.querySelector("#start").addEventListener("click", this.navigate.bind(this, 1));

        this.querySelectorAll(".question").forEach((question) => {
            const questionId = question.getAttribute("data-question-id");
            question.querySelectorAll(".question_option").forEach((option) => option.addEventListener("click", this.select.bind(this, questionId, option)));
        });

        this.querySelectorAll(".question_go-back").forEach((goBack) => goBack.addEventListener("click", this.navigate.bind(this, -1)))

    }

    connectedCallback() {}

    navigate(step) {
        this.currentPage += step;
        this.updateDisplay();
    }

    updateDisplay() {
        this.querySelector(".quiz_page[active='true']").style.opacity = 0;
        setTimeout(() => {
            this.querySelector(".quiz_page[active='true']").removeAttribute("active");

            this.querySelector(`.quiz_page[data-page-id="${this.currentPage}"]`).style.opacity = 1;
            this.querySelector(`.quiz_page[data-page-id="${this.currentPage}"]`).setAttribute("active", "true");

            const currentPage = this.querySelector(`.quiz_page[data-page-id="${this.currentPage}"]`);
            if (currentPage && currentPage.classList.contains('quiz_result')) {
                this.getResult();
                const winnerCollection = this.result?.[0]?.collection;
                const currentCollection = currentPage.getAttribute("data-collection");
                if (winnerCollection && currentCollection !== winnerCollection) {
                    this.finish();
                }
            }
        }, 300);

    }

    select(questionId, option) {
        this.querySelectorAll(`.question[data-question-id="${questionId}"] .question_option`).forEach((option) => option.removeAttribute("selected"));
        option.setAttribute("selected", "true");
        setTimeout(() => {
            this.navigate(1)
        }, 300);
    }

    finish() {
        const winnerColection = this.result[0].collection;

        this.currentPage = parseInt(this.querySelector(`.quiz_result[data-collection="${winnerColection}"]`).getAttribute("data-page-id"));
        this.updateDisplay();
    }

    getResult() {
        const selectedOptions = document.querySelectorAll('.question .question_option[selected="true"]');
        const collectionCount = {};

        selectedOptions.forEach(option => {
            const collection = option.getAttribute('data-related-collection');
            collectionCount[collection] = { count: (collectionCount[collection]?.count || 0) + 1, priority: parseInt(option.getAttribute('data-related-collection-priority')) };
        });


        const result = Object.keys(collectionCount)
            .map(key => ({
                collection: key,
                count: collectionCount[key].count,
                priority: collectionCount[key].priority
            }))
            .sort((a, b) => {
                if (b.count !== a.count) {
                    return b.count - a.count;
                }
                return b.priority - a.priority;
            });

        this.result = result;
    }

}

customElements.define("quiz-minimal", Quiz);